import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { createOnboardingProcessStepApi } from "#modules/onboardingV2/infra/createOnboardingProcessStep.api";
import { onboardingProcessStepsQuery } from "#modules/onboardingV2/infra/onboardingProcessSteps.query";

export const useCreateOnboardingProcessStep = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: createOnboardingProcessStepApi,
    onSuccess: () => {
      void queryClient.invalidateQueries(onboardingProcessStepsQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { createOnboardingProcessStep: mutate, ...rest };
};
